//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { publishedContentCounts, renderContentCount } from '@motionelements/core/src/helpers/contentCount.js';
import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import SubscribePrice from './price/SubscribePrice.vue';
import SubscribeHeroBanner from './SubscribeHeroBanner.vue';
import SubscribeStats from './SubscribeStats.vue';

export default {
  name: 'SubscribeHero',
  components: {
    SubscribeHeroBanner,
    SubscribePrice,
    SubscribeStats,
  },
  data() {
    return {
      faCheck,
      faMeSubscription,
    };
  },
  computed: {
    subscriptionElementCount() {
      return renderContentCount(this, publishedContentCounts.total.subscription.element);
    },
  },
};
